var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionMenuGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2317_8649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 13.4167C17.5 12.4507 18.284 11.6667 19.25 11.6667C20.216 11.6667 21 12.4507 21 13.4167C21 14.3827 20.216 15.1667 19.25 15.1667C18.284 15.1667 17.5 14.3827 17.5 13.4167ZM12.25 13.4167C12.25 12.4507 13.034 11.6667 14 11.6667C14.966 11.6667 15.75 12.4507 15.75 13.4167C15.75 14.3827 14.966 15.1667 14 15.1667C13.034 15.1667 12.25 14.3827 12.25 13.4167ZM7 13.4167C7 12.4507 7.784 11.6667 8.75 11.6667C9.716 11.6667 10.5 12.4507 10.5 13.4167C10.5 14.3827 9.716 15.1667 8.75 15.1667C7.784 15.1667 7 14.3827 7 13.4167Z",
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2317_8649",
    x: 3,
    y: 7.66666,
    width: 22,
    height: 11.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2317_8649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2317_8649",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionMenuGlow);
export default __webpack_public_path__ + "static/media/action_menu_glow.b790eaa3a3717b1f5be2b95a43ca5423.svg";
export { ForwardRef as ReactComponent };